module.exports = __webpack_public_path__ + "static/media/formulario.a6f73121.svg";